import SettingMenu from './SettingMenu';

export default SettingMenu;
